import { useCallback, useEffect, useState } from 'react';

import {
  RecentCompany,
  STORAGE_KEY,
  getRecent,
  rememberCompany as rememberInStorage,
} from './recent-companies';

import { Company } from '@/services/hsm-backend';

export function useRecentCompanies() {
  const [recent, setRecent] = useState<RecentCompany[]>([]);

  useEffect(() => {
    setRecent(getRecent());

    // Sync con otras tabs: si el usuario busca en otra ventana, la
    // card "RECIENTES" de esta tab se actualiza sin refresh manual.
    const handleStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY || event.key === null) {
        setRecent(getRecent());
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const remember = useCallback((company: Company) => {
    rememberInStorage(company);
    setRecent(getRecent());
  }, []);

  return { recent, remember };
}
